import type { ZXCVBNFeedback, ZXCVBNScore } from 'zxcvbn';
import zxcvbn from 'zxcvbn';

export type PasswordStrengthScore = ZXCVBNScore;
export type PasswordStrengthFeedback = ZXCVBNFeedback;

export type PasswordStrengthDetails = {
  score: PasswordStrengthScore;
  suggestions: string[];
};

export const scoreMustBeGreaterThan = 2;

const getPasswordInformation = (password: string): PasswordStrengthDetails => {
  const result = zxcvbn(password);
  return {
    score: result.score,
    suggestions: result.feedback.suggestions,
  };
};

const meetsRequirement: (password: string) => boolean = password =>
  getPasswordInformation(password).score > scoreMustBeGreaterThan;

export const PasswordStrengthUtil = {
  getPasswordInformation,
  meetsRequirement,
};
